import React from "react"

import FieldProto from "../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"
import Board_Manager from "../../../../../gd-modules/tasks-view/board/managers/manager"

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {value: number}
        children        : {value: number}
        total           : {value: number}

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldNumber_BoardAggregate"
const debug = false

export default function FieldNumber_BoardAggregate(props: Props) {

    const value = props.calculatedData?.total.value
    const isValid = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', value)

    let decimalPlaces = props.field.decimalPlaces
    let valueLabel

    if (isValid) {
        valueLabel = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);
    }

    const showLabel = isValid && !!value
    const classes = Classes("flex-no-shrink", props.className, {
        'show-on-hover': !showLabel
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
        >
            <div className="flex-row-left-center">
                {/*{props.field.icon &&
                    <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>}*/}
                <div className="ui5-txt-not-important-small">
                    {valueLabel}
                </div>
            </div>
        </Board_AggregateShell>
    )
}
